module.exports = __webpack_public_path__ + "img/video-placeholder-no-se.75737919.png";